"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepaidWalletTransactionType = void 0;
var PrepaidWalletTransactionType;
(function (PrepaidWalletTransactionType) {
    PrepaidWalletTransactionType[PrepaidWalletTransactionType["Unknown"] = -1] = "Unknown";
    PrepaidWalletTransactionType[PrepaidWalletTransactionType["Purchased"] = 0] = "Purchased";
    PrepaidWalletTransactionType[PrepaidWalletTransactionType["Used"] = 1] = "Used";
    PrepaidWalletTransactionType[PrepaidWalletTransactionType["Refunded"] = 2] = "Refunded";
    PrepaidWalletTransactionType[PrepaidWalletTransactionType["Renewed"] = 3] = "Renewed";
    PrepaidWalletTransactionType[PrepaidWalletTransactionType["Failed"] = 4] = "Failed";
    PrepaidWalletTransactionType[PrepaidWalletTransactionType["Import"] = 5] = "Import";
    PrepaidWalletTransactionType[PrepaidWalletTransactionType["Revenue"] = 6] = "Revenue";
    PrepaidWalletTransactionType[PrepaidWalletTransactionType["Converted"] = 7] = "Converted";
})(PrepaidWalletTransactionType = exports.PrepaidWalletTransactionType || (exports.PrepaidWalletTransactionType = {}));
